import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../deliveryTerms/DeliveryTerms.scss";
import useForm from "./useForm";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import ErrorMessage from "../../components/common/ErrorMessage";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";

const AddDeliveryTerms = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    values,
    setValues,
    handleFormChange,
    handleSubmit,
    handleCheck,
    show,
    setShow,
    createMsg,
    setCreateMsg,
    errors,
    errorShow,
    ErrorDoneClick,
    SuccessDoneClick,
    transportModes,
    modes,
    loading,
  } = useForm();

  const handleRedirect = () => {
    setValues({});
    navigate("/delivery-terms");
  };

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
      detail: {
        pathname: location.pathname,
        title: values?.id ? "Edit Delivery Term" : "New Delivery Term",
        backTarget: { pathname: "/delivery-terms" },
      },
    }));

    return () => {
      window.dispatchEvent(new CustomEvent("pathfinderHeaderMetaChange", {
        detail: {
          pathname: location.pathname,
          clear: true,
        },
      }));
    };
  }, [values?.id, location.pathname]);


  return (
    <>
      <div className="container-fluid add-delivery-terms-sec">
        {/* <!-- add-new-sec starts --> */}
        <div className="row mb-3">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card">
              <div className="card-body">
                  <div className="card bg-white mb-2">
                    <div className="card-header">
                      <h2>General Information</h2>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <label>
                              Abbreviation <span className="mandatory">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="abbreviation"
                              placeholder={PlaceHolder?.ABBREVIATION}
                              value={values?.abbreviation}
                              onChange={handleFormChange}
                            ></input>
                            {errors?.abbreviation && (
                              <p className="form-error">{errors?.abbreviation}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <label>
                              Delivery Terms <span className="mandatory">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="deliveryDescription"
                              placeholder={PlaceHolder?.DELIVERYTERMS}
                              value={values?.deliveryDescription}
                              onChange={handleFormChange}
                            ></input>
                            {errors.deliveryDescription && (
                              <p className="form-error">{errors.deliveryDescription}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <label>Description (Tool Tips)</label>
                            <textarea
                              className="form-control"
                              name="termsTooltip"
                              placeholder={PlaceHolder?.DESCRIPTION_TOOL}
                              rows="5"
                              value={values?.termsTooltip}
                              onChange={handleFormChange}
                            ></textarea>
                            {errors.termsTooltip && (
                              <p className="form-error">
                                {errors.termsTooltip}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* <!-- add-new-sec ends --> */}
                    </div>
                  </div>
                  <div className="card bg-white">
                    <div className="card-header">
                      <h2>Transportation Information</h2>
                    </div>
                    <div className="card-body">
                      <div className="row pl-3">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                          <h6>
                            Mode of Transport <span className="mandatory">*</span>
                          </h6>
                          <div className="d-flex flex-wrap">
                            {transportModes &&
                              transportModes?.map((item, index) => (
                                <div key={item?.id} class="form-group mb-0 mt-2">
                                  <input
                                    className="mr-2 input-checkbox d-none"
                                    type="checkbox"
                                    style={{ cursor: "pointer" }}
                                    //  className="custom-control-input custom-control-input-blue"
                                    id={item?.id}
                                    name={item?.transportationMode}
                                    checked={modes?.includes(item?.id)}
                                    value={item?.id}
                                    onChange={(e) => handleCheck(e, item?.id)}
                                  />
                                  <label
                                    for={item?.id}
                                    className="mr-5 mb-0 check-box-label"
                                  >
                                    {item?.transportationMode}
                                  </label>
                                </div>
                              ))}
                          </div>
                        </div>
                        {errors.transportMode && (
                          <p className="form-error">{errors.transportMode}</p>
                        )}
                      </div>
                      <div className="row mt-2 pl-3">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                          <div>
                            <h6>Country & Destination</h6>
                            <div className="d-flex flex-wrap mt-2">
                              <div class="form-group mb-2 mb-sm-0">
                                <input
                                  type="checkbox"
                                  id="countryRequired"
                                  name="countryRequired"
                                  value={values?.countryRequired}
                                  checked={values?.countryRequired}
                                  onChange={handleFormChange}
                                  className="mr-2 input-checkbox d-none"
                                />
                                <label
                                  for="countryRequired"
                                  className="mr-5 mb-0 check-box-label"
                                >
                                  Country Required
                                </label>
                              </div>
                              <div class="form-group mb-0">
                                <input
                                  type="checkbox"
                                  id="destinationRequired"
                                  name="destinationRequired"
                                  value={values?.destinationRequired}
                                  checked={values?.destinationRequired}
                                  onChange={handleFormChange}
                                  className="mr-2 input-checkbox d-none"
                                />
                                <label
                                  for="destinationRequired"
                                  className="mr-5 mb-0 check-box-label"
                                >
                                  Destination Required
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2 mb-2">
                          <div>
                            {values?.id && (
                              <div>
                                <h6>
                                  Status <span className="mandatory">*</span>
                                </h6>
                                <div class="form-group mb-0 mt-2">
                                  <input
                                    type="checkbox"
                                    id="isActive"
                                    name="isActive"
                                    value={values?.isActive}
                                    checked={values?.isActive}
                                    onChange={handleFormChange}
                                    disabled={!values?.id}
                                    className="input-checkbox d-none"
                                  />
                                  <label
                                    for="isActive"
                                    className="check-box-label label-d-inline-flex mr-5"
                                  >
                                    {values?.isActive ? "Active" : "Inactive"}
                                  </label>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3 mb-3">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="save-btns d-flex justify-content-end">
                        <button
                          className="btn cancel-btn"
                          onClick={handleRedirect}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn save-btn"
                          onClick={handleSubmit}
                          disabled={loading}
                        >
                          {values?.id ? "Update" : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SaveSuccessModel
        createMsg={createMsg}
        setCreateMsg={setCreateMsg}
        setShow={setShow}
        show={show}
        SuccessDoneClick={SuccessDoneClick}
      />
      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />
    </>
  );
};

export default AddDeliveryTerms;
